<template>
  <v-app id="agentCom">
    <v-main>
      <v-container fluid>
        <v-row>
          <v-col cols="2">
            <v-select v-model="bedrCodesSelected" :items="bedrCodes" item-value="bedrCode"  item-text="bedrCode" label="Companies" multiple></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="2">
            <v-select v-model="Param2.maandKeuze" :items="maandCodes" item-value="maandCode"  item-text="maandOms" label="Year / Month"></v-select>
          </v-col>
        </v-row>  
        <v-row>    
          <v-col cols="1">
            <v-btn class="primary ma-0" small :disabled="submitted" @click="ovrz">Create proforma invoices</v-btn>
          </v-col> 
        </v-row>
      </v-container>
      <lin_prg_bar ref="showProgress"></lin_prg_bar>
    </v-main>
    <navBar title="Ares - Sales partners" :home="true" type="inpt"/>
  </v-app>
</template>

<script>
import navBar from "@/components/ui/navbars/navbar.vue";
import lin_prg_bar from '@/components/ind_prg_horizontal';

 export default {
  components: {
    navBar,
    lin_prg_bar
  },
  data() {
    return {
      bedrCodesSelected: [],
      bedrCodes: [],
      maandCodesSelected: '',
      maandCodes: [],
      submitted: false,
      Param2: {},
      stopInterval: false,
    }
  },
  created() {
    var deze = this;
      this.$axios
      .post("ares/json/ares/task/inpt/ipfc/getCrIpfcParam2.p", {
        header: {
          token: this.$session.get("ARES"),
          clientSessionId: this.$session.id(),
          request: "getCrIpfcParam2"
        },
        getCrIpfcParam2: {}
      })
      .then(res => {
        if (res.data.error) {
          console.log(res.data.error);
        } else {
           this.Param2 = res.data.getCrIpfcParam2; 
           res.data.getCrIpfcParam2.bedrKeuzes.forEach(function(bedr) {
             deze.bedrCodes.push(bedr.bedrCode);
             if (bedr.bedrSelected === true) {
                deze.bedrCodesSelected.push(bedr.bedrCode);
             }
           });
           res.data.getCrIpfcParam2.maandKeuzes.forEach(function(maand) {
             deze.maandCodes.push(maand);
           });
        }
      });
  },
  methods: {
     checkStopCondition() {
      this.$axios
        .post("ares/json/ares/task/inpt/ipfc/crIpfc2_2c.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "crIpfc2_2c"
          },
        })
        .then(res => {
          if (res.data.error) {
            this.stopInterval = true;
          } else {
            this.stopInterval = res.data.crIpfc2_2c.stop;
          }
        });
     },
     ovrz() {
      this.results = true;
      this.submitted = true;
      this.$refs.showProgress.open('Generating proforma invoices...please wait', true, 0);
      this.$axios
        .post("ares/json/ares/task/inpt/ipfc/crIpfc2_2.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "crIpfc2"
          },
          crIpfc2: {
            bedr_codes: this.bedrCodesSelected,
            maandJaar: this.Param2.maandKeuze
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
            this.$refs.showProgress.close();      
          } else {
            const intervalId = setInterval(() => {
              this.checkStopCondition(); 
              if (this.stopInterval) {
                this.$refs.showProgress.close();    // stop progress dialog  
                clearInterval(intervalId); // Stop the interval
                this.$router.reload('/task/inpt/ipfc/searchIpfcTmp'); // load the result page
              }
            }, 500);
            this.submitted = false;
          }
        })
    },
  }
};

</script> 
